import React, { useState } from "react";
import { DataTable } from "../../../Components/Table/DataTable";
import {
  IDataTableProps,
  MobileLogoRenderType,
  RenderType,
} from "../../../Components/Table/interfaces/IDataTableProps";
import { Avatar, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { IProduct, clearProductStateSync, defaultProduct, fetchProductListWithArgsAsync, upsertSingleProductAsync } from "../../../redux/inventory";
import { IStoreState, useAppDispatch, useAppSelector } from "../../../redux";
import { useDateFilter } from "../../../Components/Table/hooks/useDateFilter";
import { useNavigate } from "react-router-dom";
import { formatDate, formatDateWithTime } from "../../../helpers";
import { StandardTableActions } from "../../../Components/StandardTableActions/StandardTableActions";
import { PRODUCTS_ROUTE } from "../Inventory.constants";
import { LoadState } from "../../../constants/enum";
import { useOutletContext } from "../../../providers";
import { BorderColor, Cancel, Edit, Save } from "@mui/icons-material";
import { OutlinedTextField } from "../../../Components/formComponents";
import { useFormik } from "formik";

export const ProductsTable = () => {
  const { outlet_details: { outlet_uuid } } = useOutletContext()
  const {
    data: productsList,
    totalRecords: totalRecords,
    loading,
  } = useAppSelector((storeState: IStoreState) => storeState.inventory.products.product_list);
  const [allProductsList, setAllProductsList] = useState<IProduct[]>([])
  const [pagination, setPagination] = React.useState({
    pageNumber: 1,
    rowsPerPage: 25,
  });

  const dispatch = useAppDispatch();
  const navigate = useNavigate();


  const productsTableProps: IDataTableProps = {
    isPagination: true,
    totalRecords: totalRecords,
    rowsPerPageOptions: pagination.rowsPerPage,
    isDataLoading: loading !== LoadState.succeeded,
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },
    columns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IProduct) => {
          return (
            <StandardTableActions
              onEditClick={() => navigate(`${PRODUCTS_ROUTE}/manage/${row.product_uuid}`)}
            />
          );
        },
      },
      {
        key: "product_name",
        headerName: "Product Name",
        fieldName: "product_name",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IProduct) => {
          return (
            <Typography variant="h6" fontWeight={"bold"} letterSpacing={-0.5}>
              {row.product_name}
            </Typography>
          );
        },
      },
      {
        key: "product_description",
        headerName: "Description",
        fieldName: "product_description",
        turncateLength: 10,
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IProduct) => {
          return (
            <Typography variant="h6" fontWeight={"bold"} letterSpacing={-0.5}>
              {row.product_description.substring(0, 10)}
            </Typography>
          );
        },
      },
      {
        key: "category_name",
        headerName: "Category",
        fieldName: "category_name",
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,
        enableSorting: true,
      },
      {
        key: "product_sale_price",
        headerName: "Sell Price",
        fieldName: "product_sale_price",
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
      },
      {
        key: "product_price",
        headerName: "Cost Price",
        fieldName: "product_price",
        exportCellWidth: 25,
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
      },
      {
        key: "product_type",
        headerName: "Product Type",
        fieldName: "product_type",
        exportCellWidth: 25,
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        exportCellWidth: 25,
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
      },
      {
        key: "insert_ts",
        headerName: "Date",
        fieldName: "insert_ts",
        enableSorting: true,
        renderType: RenderType.DATE_DARK_COLOR,
        exportCellWidth: 25,
        headingAlign: "center",
        onExportRender: (values) => {
          return formatDateWithTime(values.value);
        },
      },
    ],

    items: productsList,
    onPageChange: (newPageNumber: number) => {
      setPagination({ ...pagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setPagination({
        pageNumber: pageNumber,
        rowsPerPage: rowsPerPage,
      });
    },
  };


  const fetchList = () => {
    if (!outlet_uuid) return
    dispatch(
      fetchProductListWithArgsAsync({
        outlet_uuid,
        page: pagination.pageNumber,
        rowsPerPage: pagination.rowsPerPage,
      }),
    );
  };

  React.useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, outlet_uuid]);

  React.useEffect(() => {
    setAllProductsList(productsList || [])
  }, [productsList]);


  React.useEffect(() => {
    return () => {
      dispatch(clearProductStateSync());
    };
  }, []);

  console.log("allProductsList ==> ", allProductsList)

  return <>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Actions</TableCell>
            <TableCell>Product Name</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Product Price</TableCell>
            <TableCell>Product Type</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Date Created</TableCell>

          </TableRow>
        </TableHead>
        <TableBody>
          {(allProductsList).map((row, r_index) => (
            <SingleProductDetails key={r_index} index={r_index} product={row} onSaveSuccess={fetchList} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    {/* <DataTable {...productsTableProps} /> */}
  </>
};


interface ISingleProductDetailsPRops {
  index: number;
  product: IProduct;
  onSaveSuccess: () => void;
}

const SingleProductDetails: React.FC<ISingleProductDetailsPRops> = ({ product, index, onSaveSuccess }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [enableQuickEdit, setEnableQuickEdit] = useState<boolean>(false)
  const {
    values,
    errors,
    setValues,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: defaultProduct,
    enableReinitialize: true, // important: keeps values in sync when product changes
    validate: (values) => {
      const errors: any = {};
      if (!values.product_price) {
        errors.product_price = "*This field is required.";
      } else if (Number(values.product_price) <= 0) {
        errors.product_price = "*Product price should be grater than 0.";
      }
      return errors;
    },
    onSubmit: async (values) => {
      dispatch(
        upsertSingleProductAsync({ ...values, file: null })
      ).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          setEnableQuickEdit(false)
          onSaveSuccess()
        }
      })
    },
  });


  React.useEffect(() => {
    setValues(product);
  }, [product]);

  
  const handleCancelClick = () => {
    setValues(product);
    setEnableQuickEdit(false)
  }

  return (
      <TableRow
        key={index}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell component="th" scope="row">
          <>
            {!enableQuickEdit ? (
              <>
                <IconButton onClick={() => navigate(`${PRODUCTS_ROUTE}/manage/${values.product_uuid}`)}>
                  <Edit />
                </IconButton>
                <Tooltip title="Quick Edit">
                  <IconButton onClick={() => setEnableQuickEdit(true)}>
                    <BorderColor />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <>
                <Tooltip title="Save">
                  <IconButton onClick={() => handleSubmit()} >
                    <Save />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Cancel">
                  <IconButton onClick={handleCancelClick}>
                    <Cancel />
                  </IconButton>
                </Tooltip>
              </>

            )}
          </>
        </TableCell>
        <TableCell>{values.product_name}</TableCell>
        <TableCell>{values.product_description}</TableCell>
        <TableCell>{values.category_name}</TableCell>
        <TableCell>{enableQuickEdit ? (
          <OutlinedTextField
            id="product_price"
            placeholder="Enter Price"
            value={values.product_price}
            onChange={handleChange}
            error={errors.product_price}
          />
        ) : values.product_price
        }</TableCell>
        <TableCell>{values.product_type}</TableCell>
        <TableCell>{values.status}</TableCell>
        <TableCell>{formatDate(values.create_ts || "")}</TableCell>
      </TableRow>
  )

}
